/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { isUS } from "@utils/userSegment";
import "./FooterPayment.less";
import { Text } from "../core/Text";
import { disclaimerLinks } from "./DisclaimerLinks";

type Props = {
  contactTranslationKey?: string;
};

/**
 * Footer shown on the Payment page
 */
function PaymentFooter({ contactTranslationKey = "contact" }: Props) {
  if (isUS()) {
    // Use copy without additional line breaks for contactWithoutTC only
    const translationKeyUSCore =
      contactTranslationKey === "contactWithoutTC"
        ? "contactWithoutTCCompact"
        : contactTranslationKey;
    return (
      // Use different styling when smartphone req footer is enabled
      <footer className="footer-with-smartphone-req">
        <Text
          parent="div"
          i18nKey={`paymentFooter:${translationKeyUSCore}`}
          components={disclaimerLinks}
        />
      </footer>
    );
  }
  return (
    <footer className="footer">
      <Text
        parent="div"
        i18nKey={`paymentFooter:${contactTranslationKey}`}
        components={disclaimerLinks}
      />
    </footer>
  );
}

export default PaymentFooter;
